module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-light-gray@3x-7c3fa50e6bbbd1862af79efaa4f60cdb.png";